module.exports = __webpack_public_path__ + "img/200.375f4eeb.png";